import React from 'react';
import { useNavigate } from 'react-router-dom';

import FilterChip from './FilterChip';

import { useFilterCards } from 'buyside/util/filter/formatFilter';

import styles from './indexFilterChipsStyles.scss';

const IndexFilterChips: React.FC = (): React.ReactElement | null => {
  const filterCards = useFilterCards();

  const navigate = useNavigate();

  if (!filterCards.length) return null;

  return (
    <div className={styles.container}>
      <div className={styles.chipContainer}>
        {filterCards.map(
          ({
            paramName,
            paramValue,
            categoryDisplayText,
            valueDisplayText
          }): React.ReactElement => (
            <FilterChip
              key={`${categoryDisplayText}-${valueDisplayText}`}
              label={categoryDisplayText}
              value={valueDisplayText}
              paramName={paramName}
              paramValue={paramValue}
            />
          )
        )}
      </div>
      <button className={styles.clearAll} onClick={() => navigate({ pathname: '/', search: '' })}>
        Clear all
      </button>
    </div>
  );
};

export default IndexFilterChips;
